import { FC } from 'react'
import styles from './DocumentOperationSpinner.module.scss'

interface IDocumentOperationSpinnerProps {
    xl?: boolean
    style?: React.CSSProperties
    className?: string
    'data-testid'?: string;
}

export const DocumentOperationSpinner : FC<IDocumentOperationSpinnerProps> = (props) => {
    return (
        <div className={ props.xl ? styles.xlWrapper : styles.wrapper }>

            <i className={props.xl ? styles.xlSpinner : styles.spinner}></i>
            {props.xl ? (<div className={styles.xlText}>Идет загрузка, подождите, пожалуйста...</div>) : null}
                
        </div>

    )
}